import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlPopinResponse extends IIsiDtoPresentationLogicResponse  {
}
export class IsiDtoPlPopinResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlPopinResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.PresentationLogic.Popin.IsiDtoPlPopinResponse, Isilog.IsiComponent.IsiDataTransferObject";

    constructor(data?: IIsiDtoPlPopinResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoPlPopinResponse): IsiDtoPlPopinResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlPopinResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export interface IIsiDtoPlPopinRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlPopinResponse;
}
export class IsiDtoPlPopinRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlPopinRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.PresentationLogic.Popin.IsiDtoPlPopinRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlPopinResponse;

    constructor(data?: IIsiDtoPlPopinRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlPopinResponse(data.response) : <IsiDtoPlPopinResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlPopinResponse.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlPopinRequest): IsiDtoPlPopinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlPopinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
